export const APPOINTMENT_VISIT_PAYMENT_FAILED = 'APPOINTMENT_VISIT_PAYMENT_FAILED';